import { REDIRECT_DEMAND_FILTER } from '../../actions/actionTypes';

const initialState = {
  redirectDemandFilter: "",
};

const redirectDemandFilter = (state = initialState, action) => {
  switch (action.type) {
    case REDIRECT_DEMAND_FILTER:
      return {
        ...state,
        redirectDemandFilter: action.payload,
      };
    default:
      return state;
  }
};

export default redirectDemandFilter;